import RoutesConstants from '../../../routes/RoutesConstant';

export const defaultRoute = RoutesConstants.HelpCenter;
export const searchRoute = RoutesConstants.HelpCenterSearch;
export const resultRoute = RoutesConstants.HelpCenterResult;
export const mediaRoute = RoutesConstants.HelpCenterMedia;
